module.exports = __webpack_public_path__ + "img/Cloud.79b3c647.svg";